import axios from "axios";
import React, { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import Select from "react-select";
import { customSelectStyle } from "../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle";
import { INSTALLLMENTS } from "./constants";
import { PlanFormWarnings } from "./PlanFormWarnings";

export default function Step1(props) {
  const [isLoading,setIsLoading] = useState(true);
  const [featureGroups,setFeatureGroups] = useState({});
  const [displayValue, setDisplayValue] = useState("");

  const loadFeatureGroups = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feature_groups?page_size=999999`
    );
    let featureGroups = response.data.data.data;
    setFeatureGroups(featureGroups);
    setIsLoading(false);
  };

  useEffect(() => {
    loadFeatureGroups();
  }, []);
  
  const formatToCurrency = (value) => {
    const number = Number.parseFloat(value);
    return number.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  const handleChange = (e) => {
    let { value } = e.target;
    setDisplayValue(value);
  };

  const handleBlur = () => {
    let numericValue = displayValue.replace(/[^\d,]/g, "").replace(",", ".");
    numericValue = parseFloat(numericValue) || 0;
    
    const formattedValue = formatToCurrency(numericValue);
    
    setDisplayValue(formattedValue);
    props.formik.setFieldValue("amount", numericValue);
  };

  useEffect(() => {
    if (!isNaN(props.formik.values.amount)) {
      const formattedValue = formatToCurrency(props.formik.values.amount);
      setDisplayValue(formattedValue);
    }
  }, [props.formik.values.amount]);

  return (
    <BlockUi tag="div" blocking={props.formik.isSubmitting}>
      <div className="row no-gutters mb-20">
        <div className="col-xl-12">
          <div
            className="border-radius-only-left"
            style={{ backgroundColor: "#fff", padding: "40px", height: "100%" }}
          >
            <PlanFormWarnings planId={props.id} formik={props.formik} />
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                  Nome <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  className={
                    "form-control " +
                    (props.formik.errors.name && props.formik.touched.name
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.name}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.name && props.formik.touched.name && (
                  <label className="invalid-feedback">
                    {props.formik.errors.name}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                  Duração (em dias)<span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="number"
                  name="periodicity"
                  className={
                    "form-control " +
                    (props.formik.errors.periodicity && props.formik.touched.periodicity
                      ? "is-invalid"
                      : "")
                  }
                  value={props.formik.values.periodicity}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.periodicity &&
                props.formik.touched.periodicity && (
                  <label className="invalid-feedback">
                    {props.formik.errors.periodicity}
                  </label>
                )}
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                    Valor do plano <span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="text"
                  name="amount"
                  disabled={Boolean(props.id)}
                  className={
                    "form-control " +
                    (props.formik.errors.amount && props.formik.touched.amount ? "is-invalid" : "")
                  }
                  value={displayValue}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {props.formik.errors.amount && props.formik.touched.amount && (
                  <label className="invalid-feedback">
                    {props.formik.errors.amount}
                  </label>
                )}
              </div>
              <div className="col-xl-6">
                <label className="form-label">
                Parcelas <span class="text-danger">&nbsp;*</span>
                </label>
                <Select
                  name="installments"
                  isSearchable={true}
                  isClearable={true}
                  options={INSTALLLMENTS}
                  className={
                    props.formik.errors.installments &&
                  props.formik.touched.installments
                      ? "is-invalid"
                      : ""
                  }
                  onChange={option => {
                    props.formik.setFieldValue("installments", option ? option.value : "");
                  }}
                  value={INSTALLLMENTS.find(option => option.value === props.formik.values.installments||"")}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.label}
                  getOptionValue={option => option.value}
                  theme={customSelectStyle}
                />
                {props.formik.errors.installments &&
                props.formik.touched.installments && (
                  <label className="invalid-feedback">
                    {props.formik.errors.installments}
                  </label>
                )}
              </div>
            </div>

            <div className="row mb-5">
              <div className="col-xl-6">
                <label className="form-label">
                    Dias de Trial<span class="text-danger">&nbsp;*</span>
                </label>
                <input
                  type="number"
                  name="trial_days"
                  className={
                    "form-control " +
                      (props.formik.errors.trial_days && props.formik.touched.trial_days
                        ? "is-invalid"
                        : "")
                  }
                  value={props.formik.values.trial_days}
                  onChange={props.formik.handleChange}
                />
                {props.formik.errors.trial_days && props.formik.touched.trial_days && (
                  <label className="invalid-feedback">
                    {props.formik.errors.trial_days}
                  </label>
                )}
              </div>

              <div className="col-xl-6">
                <label className="form-label">
                  Grupo de planos <span class="text-danger">&nbsp;*</span>
                </label>
                {!isLoading? <Select
                  name="feature_group_id"
                  isSearchable={true}
                  isClearable={true}
                  options={featureGroups}
                  className={
                    props.formik.errors.feature_group_id &&
                    props.formik.touched.feature_group_id
                      ? "is-invalid"
                      : ""
                  }
                  onChange={option => {
                    props.formik.setFieldValue("feature_group_id", option.id);
                  }}
                  value={featureGroups.find(option => option.id === props.formik.values.feature_group_id)}
                  placeholder="Selecione.."
                  getOptionLabel={option => option.name}
                  getOptionValue={option => option.id}
                  theme={customSelectStyle}
                />:null}
                {props.formik.errors.feature_group_id &&
                  props.formik.touched.feature_group_id && (
                  <label className="invalid-feedback">
                    {props.formik.errors.feature_group_id}
                  </label>
                )}
              </div>
            </div>       
            <div className="row mb-5">
              <div className="col-xl-12">
                <button
                  type="button"
                  onClick={props.formik.handleSubmit}
                  className="btn btn-primary"
                  style={{ width: "100%", height: "50px" }}
                >
                  SALVAR PLANO
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </BlockUi>
  );
}
